import { referenceConstants } from '../../constants'

const initialState = {
  date: [],
  status: [],
  select:{},
  prev:{},
  next:{},
  isLoading: false,
  isFailure: false,
  page : 0,
}

export default function reference(state = initialState, action) {
  switch (action.type) {
    /*********
     리스트
    **********/

    case referenceConstants.LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case referenceConstants.LOAD_SUCCESS:
      let data = action.response.data.payload;
      data.schCode = action.params?.schCode;
      data.schText = action.params?.schText;

      return{
        ...state,
        data: data,
      }
    case referenceConstants.LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }

      /*********
       상세화면
       **********/

    case referenceConstants.DETAILS_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case referenceConstants.DETAILS_SUCCESS:
      return {
        ...state,
        select: action.response.data.payload?.content,
        prev: action.response.data.payload?.prev,
        next: action.response.data.payload?.next,
      }
    case referenceConstants.DETAILS_FAILURE:
      return {
        isLoading: false,
        isFailure: true
      }


      /*********
     선택
    **********/

    case referenceConstants.SELECT_REQUEST:

      window.open('/canvasNew/composeViewer_new.htm?menuId=104&cntrctNo='+ action.params, '_blank')

      return {
        ...state,
        isLoading: !state.isLoading,
      }
    default:
      return state
  }
}
